if (!customElements.get('announcement-bar-sh-fade')) {
  class AnnouncementBarSHFade extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.announcement-bar-sh__fade-slide'));
      if (this.slides.length < 2) return;
      this.currentIndex = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      this.prevButton = this.querySelector('.slider-button--prev');
      this.nextButton = this.querySelector('.slider-button--next');
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.go(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.go(1));

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resumeIfWasPlaying());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resumeIfWasPlaying());

      if (this.dataset.autoplay === 'true' && !this.reducedMotion.matches) this.play();
    }

    go(direction) {
      const nextIndex = (this.currentIndex + direction + this.slides.length) % this.slides.length;
      this.slides[this.currentIndex].classList.remove('is-active');
      this.slides[this.currentIndex].setAttribute('aria-hidden', 'true');
      this.slides[nextIndex].classList.add('is-active');
      this.slides[nextIndex].removeAttribute('aria-hidden');
      this.currentIndex = nextIndex;
    }

    play() {
      this.wasPlaying = true;
      clearInterval(this.autoplay);
      const speed = (parseFloat(this.dataset.speed) || 5) * 1000;
      this.autoplay = setInterval(() => this.go(1), speed);
    }

    pause() {
      clearInterval(this.autoplay);
      this.autoplay = null;
    }

    resumeIfWasPlaying() {
      if (this.wasPlaying && this.dataset.autoplay === 'true' && !this.reducedMotion.matches) this.play();
    }
  }

  customElements.define('announcement-bar-sh-fade', AnnouncementBarSHFade);
}
